import {Select} from "antd";
import React, {useMemo} from "react";
import {countryCodesList} from "../../utils/countryCodesList";
import "./countries-selector.css";

interface CountryOption {
    countryName: string;
    country: string;
    code: number;
    customLabel?: string;
}

interface CountriesSelector {
    selectedCountry: string;
    setSelectedCountry: (newVal: string) => void;
    valueProp: 'country' | 'countryName' | 'code';
    isDisabled?: boolean;
    hideCountryName?: boolean;
    size?: "normal" | "big";
    options?: CountryOption[];
    width?: number;
}

const CountriesSelector = ({ size = "normal", selectedCountry, setSelectedCountry, valueProp, isDisabled = false, hideCountryName = false, options, width }: CountriesSelector) => {
    const { Option } = Select;

    const getLabel = (item: { countryName: string, country: string, code: number }) => {
        if ((item as CountryOption).customLabel) {
            return (item as CountryOption).customLabel;
        }
        if(hideCountryName) {
            return `+${item.code}`;
        } else {
            return `${item.countryName} (+${item.code})`;
        }
    }

    const onOptionClick = ({ countryName, country, code }: {countryName: string, country: string, code: number}) => {
        if(country !== selectedCountry) {
            setSelectedCountry(country);
        }
    }

    const countryOptions = useMemo(() => {
        const optionsSource = options?.length ? options : countryCodesList;
        return [...optionsSource].sort((a, b) => (hideCountryName ? a.code > b.code : a.countryName > b.countryName) ? 1 : -1).map(item => ({
            value: item[valueProp],
            label: <div className={`phone-prefix-option ${isDisabled ? 'disabled' : ''}`} key={`phone-prefix-item-${item.code}-${item.country}`} onClick={() => onOptionClick(item)}>
                <div className="phone-flag-container"><img alt={item.countryName} className="phone-flag" src={`https://flagcdn.com/w40/${item.country.toLowerCase()}.png`} /></div>
                <div className="country-code">
                    {item ? getLabel(item) : 'loading...'}
                </div>
            </div>
        }));
    }, [hideCountryName, isDisabled, options, selectedCountry, valueProp]);

    const filterCountryOptions = (input: string, option: any) => option.value.toLowerCase().includes(input.toLowerCase());

    return (
        <Select
            placeholder="Country"
            style={{ width: width || (hideCountryName ? size === 'big' ? 150 : 125 : size === 'big' ? 520 : 280), height: 46 }}
            optionFilterProp="children"
            // onChange={(newVal: string) => {
            //     setSelectedCountry(newVal);
            // }}
            value={selectedCountry}
            filterOption={filterCountryOptions}
            disabled={isDisabled}
            className={`countries-select ${size}`}
        >
            {countryOptions.map((opt) => (
                <Option key={opt.value} value={opt.value}>
                    {opt.label}
                </Option>
            ))}
        </Select>
    );
}

export default CountriesSelector;
